import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Check, Sparkles, Plus, Minus } from 'lucide-react';

const DecisionCard = ({ option, isSelected, onSelect, decisionId }) => {
  const { id, title, description, impact, badge, addedItinerary } = option;

  return (
    <Card 
      className={`group cursor-pointer overflow-hidden transition-all duration-300 rounded-sm ${
        isSelected 
          ? 'border-2 border-emerald-700 shadow-xl ring-2 ring-emerald-700/20' 
          : 'border-2 border-zinc-200 hover:border-amber-500 hover:shadow-lg'
      }`}
      onClick={() => onSelect(decisionId, id)}
    >
      <CardContent className="p-6 relative">
        {/* Badge */}
        <div className="absolute top-4 right-4">
          <span className={`px-3 py-1 rounded-full text-xs font-semibold ${
            isSelected 
              ? 'bg-emerald-700 text-white' 
              : 'bg-zinc-200 text-zinc-700'
          }`}>
            {badge}
          </span>
        </div>

        {/* Selected Indicator */}
        {isSelected && (
          <div className="absolute top-4 left-4">
            <div className="w-8 h-8 rounded-full bg-emerald-700 flex items-center justify-center">
              <Check className="w-5 h-5 text-white" />
            </div>
          </div>
        )}

        {/* Content */}
        <div className="mt-8 mb-4">
          <h4 className="text-xl font-semibold mb-3 text-zinc-900">{title}</h4>
          <p className="text-zinc-600 leading-relaxed">{description}</p>
        </div>

        {/* Impact Display */}
        <div className="flex flex-wrap gap-3 mb-4">
          {impact.days !== 0 && (
            <div className={`flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium ${
              impact.days > 0 
                ? 'bg-blue-100 text-blue-700' 
                : 'bg-green-100 text-green-700'
            }`}>
              {impact.days > 0 ? <Plus className="w-4 h-4" /> : <Minus className="w-4 h-4" />}
              <span>{Math.abs(impact.days)} {Math.abs(impact.days) === 1 ? 'day' : 'days'}</span>
            </div>
          )}
          {impact.cost !== 0 && (
            <div className={`flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium ${
              impact.cost > 0 
                ? 'bg-amber-100 text-amber-700' 
                : 'bg-green-100 text-green-700'
            }`}>
              <span>{impact.cost > 0 ? '+' : ''}${Math.abs(impact.cost)}</span>
            </div>
          )}
          {impact.difficulty !== 0 && (
            <div className={`flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium ${
              impact.difficulty > 0 
                ? 'bg-red-100 text-red-700' 
                : 'bg-green-100 text-green-700'
            }`}>
              <Sparkles className="w-4 h-4" />
              <span>Difficulty {impact.difficulty > 0 ? '+' : ''}{impact.difficulty}</span>
            </div>
          )}
        </div>

        {/* Added Itinerary */}
        {addedItinerary && addedItinerary.length > 0 && (
          <div className="mt-4 p-4 bg-zinc-50 rounded-sm border border-zinc-200">
            <p className="text-sm font-semibold text-zinc-700 mb-2">Added to Your Journey:</p>
            <ul className="space-y-1">
              {addedItinerary.map((item, idx) => (
                <li key={idx} className="text-sm text-zinc-600 flex items-start gap-2">
                  <span className="text-amber-600">•</span>
                  <span>{item.title}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default DecisionCard;